export const LOCAL_STORAGE_KEY_AUTHORIZATION: string = 'authorization';
export const LOCAL_STORAGE_KEY_DEVICE_ID: string = 'device-id';
export const LOCAL_STORAGE_KEY_PUSH_NOTIFICATION_TOKEN: string = 'push-notification-token';
export const LOCAL_STORAGE_KEY_OKTA_ACCOUNT_NAME: string = 'okta-account-name';
export const LOCAL_STORAGE_KEY_OKTA_ACCOUNT_CLIENT_ID: string = 'okta-account-client-id';
export const LOCAL_STORAGE_KEY_FIXED_NAVIGATION_DRAWER: string = 'fixed-navigation-drawer';
export const LOCAL_STORAGE_KEY_FIXED_RIGHT_DRAWER: string = 'fixed-right-drawer';
export const LOCAL_STORAGE_KEY_CARD_VIEW: string = 'card-view';
export const LOCAL_STORAGE_KEY_DEAL_SCHEDULE_ZOOM: string = 'deal-schedule-zoom';
export const LOCAL_STORAGE_KEY_PORTFOLIO_FILTER_IDS: string = 'portfolio-filter-ids';
export const LOCAL_STORAGE_KEY_PORTFOLIO_GROUP_FILTER_IDS: string = 'portfolio-group-filter-ids';
